import { isNative } from '../../utils/platform';

/* ═══════════════════════════════════════════════════════════════════════════
 * Conformité App Store — règle 3.1.3(f) « Free Standalone Apps »
 * ───────────────────────────────────────────────────────────────────────────
 * L'app Revyo est un companion GRATUIT d'un outil web payant. Le régime qui
 * s'applique n'est donc pas 3.1.1 (achats intégrés obligatoires) mais
 * 3.1.3(f), qui dispense d'in-app purchase :
 *
 *   « …provided there is no purchasing inside the app, or CALLS TO ACTION
 *     FOR PURCHASE OUTSIDE OF THE APP. »
 *
 * Ne pas vendre dans l'app NE SUFFIT PAS. Un bouton « Passer à Pro », un écran
 * tarifs, un bandeau d'upgrade ou un lien vers /abonnement sont autant d'appels
 * à l'achat hors de l'app — donc des motifs de rejet. 3.1.1(a) le confirme :
 * hors storefront américain, une app ne peut contenir « buttons, external
 * links, or other calls to action » vers un autre moyen de paiement. Revyo est
 * sur le storefront FR : la dérogation américaine ne s'applique pas.
 *
 * Conséquence pratique : SUR iOS, L'APP EST MUETTE SUR L'ARGENT.
 *   - pas de bouton ni de lien vers le paiement ou la grille tarifaire ;
 *   - pas de prix affiché pour inciter à monter de formule ;
 *   - une fonctionnalité non incluse affiche un état verrouillé neutre,
 *     sans aucune sortie.
 *
 * Sur le web, rien ne change : l'overlay et son CTA restent le moteur de
 * conversion.
 *
 * ⚠️ Toute nouvelle surface qui parle de formule, de prix ou d'upgrade doit
 * passer par ce garde. C'est la seule chose qui sépare une soumission acceptée
 * d'un rejet.
 * ═══════════════════════════════════════════════════════════════════════════ */

/** true si l'on peut afficher un appel à l'achat (bouton, lien, prix d'upsell). */
export function canShowPurchaseCta() {
  return !isNative();
}

/**
 * Message de substitution quand une fonctionnalité n'est pas incluse.
 * Constate, sans nommer de formule à acheter ni proposer de sortie.
 */
export const LOCKED_NEUTRAL_TEXT = 'Disponible sur une formule supérieure.';

export default { canShowPurchaseCta, LOCKED_NEUTRAL_TEXT };
